/*
 * Bootstrap popovers and tooltips are not event-delegated: every trigger needs
 * its own instance, and triggers arrive with each swapped partial. Registered
 * as an enhancer so they are (re)built wherever content lands. Put the
 * data-bs-toggle on a real <button>, not on a Font Awesome <i>/<span>: the
 * icon element is replaced by an <svg> after insertion and an instance bound
 * to the original node dies with it.
 */
export function initHints(root: ParentNode): void {
    const bs = window.bootstrap;
    if (!bs) return;
    for (const trigger of Array.from(root.querySelectorAll('[data-bs-toggle="popover"]'))) {
        bs.Popover.getInstance(trigger)?.dispose();
        new bs.Popover(trigger);
    }
    for (const trigger of Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]'))) {
        bs.Tooltip.getInstance(trigger)?.dispose();
        new bs.Tooltip(trigger);
    }
}
